var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HDSStep, HDSStepper } from "@here/hds-react-components/Stepper";
import { useSelector } from "react-redux";
import translations from "../../../translations/resources/en-GB.json";
import "./prcWizard.scss";
var PrcWizard = function () {
    var stepIndex = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.stepIndex; });
    var completedStep = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.completedStep; });
    var uploadStatus = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.uploadStatus; });
    var isUpdateOrder = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.isUpdateOrder; });
    return (_jsx("div", __assign({ className: "stepContainer" }, { children: uploadStatus === null && (_jsxs(_Fragment, { children: [isUpdateOrder ? (_jsx("div", __assign({ className: "orderUpdateHeadline" }, { children: translations.data["venonboard.updateMapOrder.Headline"] }))) : (_jsx("div", __assign({ className: "orderUpdateHeadline" }, { children: translations.data["venonboard.newMapOrder.Headline"] }))), _jsxs(HDSStepper, __assign({ activeStep: stepIndex, completeStep: completedStep, nonLinear: true }, { children: [_jsx(HDSStep, { label: translations.data["venonboard.wizard.step1"] }), _jsx(HDSStep, { label: translations.data["venonboard.wizard.step2"] }), _jsx(HDSStep, { label: translations.data["venonboard.wizard.step3"] })] }))] })) })));
};
export default PrcWizard;
